import React, { Component } from 'react'

import SearchForm from './SearchForm'
import HeaderLogo from './HeaderLogo'

export default class LogoSection extends Component {
	render() {
		return (
			<div className="body_container">
				<div className="logo_section">
					<SearchForm />
					<HeaderLogo />
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/header/LogoSection.js